import { graphql, useStaticQuery } from 'gatsby'

export const usePathPrefix = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        pathPrefix
      }
    }
  `)

  return data?.site?.pathPrefix ? data.site.pathPrefix : ''
}
